<template>
  <fragment>
    <template v-for="menu in menuList">
      <el-submenu
        v-if="menu.children.length > 0"
        :index="menu.path"
        :key="menu.path"
      >
        <template slot="title">
          <i :class="menu.icon"></i>
          <span style="font-size: 16px;" slot="title">
            {{ menu.label }}
          </span>
        </template>
        <menu-item :menuList="menu.children"></menu-item>
      </el-submenu>
      <el-menu-item
        @click="selectMenu(menu)"
        v-else
        :index="menu.path"
        :key="menu.path"
      >
        <i :class="menu.icon"></i>
        <span slot="title">{{ menu.label }}</span>
      </el-menu-item>
    </template>
  </fragment>
</template>

<script>
import MenuItem from "./MenuItem.vue";
import store from "../store";
export default {
  name: "MenuItem",
  props: ["menuList"],
  components: {
    MenuItem,
  },
  methods: {
    selectMenu(item) {
      //设置面包屑二级菜单
      let menu_path = "";
      if (item.parentLabel) {
        menu_path = item.parentLabel + " > " + item.label;
      } else {
        menu_path = item.label;
      }
      sessionStorage.setItem("menuPath", menu_path);
      store.state.MenuStore.menu_path = menu_path;
      //设置路由
      this.$router.push({ name: item.name });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-bar [class^="icon-"] {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 14px;
  left: 24px;
  display: inline-block;
}
.icon-home-page {
  background: url("../assets/menu-icon/icon-home-page.png") no-repeat;
}
.icon-sys-manage {
  background: url("../assets/menu-icon/icon-sys-manage.png") no-repeat;
}
.icon-devops-dept {
  background: url("../assets/menu-icon/icon-devops-dept.png") no-repeat;
}
.icon-devops-staff {
  background: url("../assets/menu-icon/icon-devops-staff.png") no-repeat;
}
.icon-area-station {
  background: url("../assets/menu-icon/icon-area-station.png") no-repeat;
}
.icon-order-manage {
  background: url("../assets/menu-icon/icon-order-manage.png") no-repeat;
}
.icon-run-monitor {
  background: url("../assets/menu-icon/icon-run-monitor.png") no-repeat;
}
.icon-car-manage {
  background: url("../assets/menu-icon/icon-car-manage.png") no-repeat;
}
.icon-device-manage {
  background: url("../assets/menu-icon/icon-device-manage.png") no-repeat;
}
.icon-device-upgrade {
  background: url("../assets/menu-icon/icon-device-upgrade.png") no-repeat;
}
.icon-uphold-manage {
  background: url("../assets/menu-icon/icon-uphold-manage.png") no-repeat;
}
.icon-data-count {
  background: url("../assets/menu-icon/icon-data-count.png") no-repeat;
}
.icon-news-push {
  background: url("../assets/menu-icon/icon-news-push.png") no-repeat;
}
.icon-app-manage {
  background: url("../assets/menu-icon/icon-app-manage.png") no-repeat;
}
.icon-monitor-geological {
  background: url("../assets/menu-icon/icon-monitor-geological.png") no-repeat;
}
.icon-insurance-manage {
  background: url("../assets/menu-icon/icon-insurance-manage.png") no-repeat;
  background-size: 20px;
}
</style>
